// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ARCHIVE_V3_LATEST_DOCUMENTS } from 'src/app/shared/utils/archive-v3-redirect.utils';

// Custom packages - Component
import { HistoricalDocsListComponent } from './pages/historical-docs-list.page';

const routes: Routes = [
  {
    // Opens historical-docs-v3 instead once the 3.0.0 archive is live (FE-A1, ArchiveV3RedirectGuard)
    path: 'list',
    component: HistoricalDocsListComponent,
    canActivate: [ArchiveV3RedirectGuard, RoleGuard],
    data: {
      permissions: ['canViewLatestDocsInsList'],
      archiveV3Redirect: ARCHIVE_V3_LATEST_DOCUMENTS,
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class HistoricalDocsRoutingModule { }
